module.exports = __webpack_public_path__ + "static/flux-hifi-1-0175810b7f52d7a9da6c4b939860fe2c.png";